module.exports = __webpack_public_path__ + "static/b8-6592a5dc58de8604d25837966373c7ff.jpg";